import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import styles from 'sections/Resources/BillOfLading/components/SectionDifferences/SectionDifferences.module.scss';

const cn = classNames.bind(styles);

const SectionDifferences = (): ReactElement => {
  return (
    <section className={cn('differences')}>
      <div className={cn('container')}>
        <div className={cn('differences__heading-box')}>
          <h2 className={cn('differences__heading')}>
            <span>Differences Between</span>
            <span> the Freight Bill and the Bill of Lading</span>
          </h2>
          <p className={cn('differences__heading-description')}>
            When working with your broker or carrier, you'll encounter both the freight bill and the Bill of
            Lading (BoL), which may appear similar but serve distinct purposes.
          </p>
        </div>

        <div className={cn('differences__paragraphs')}>
          <p className={cn('differences__paragraph')}>
            The freight bill complements the BoL by providing detailed financial information and clarifying
            shipment specifics. While the BoL indicates basic shipment details like date and location, the
            freight bill includes comprehensive cost breakdowns and additional charges incurred during
            transport. This document is crucial for accounting and financial processes, such as a freight
            audit, and is a valuable tool for identifying potential savings in your shipping operations.
          </p>
          <p className={cn('differences__paragraph')}>
            Unlike the Bill of Lading, which is a legally binding document, the freight bill does not serve as
            a service level agreement. The BoL can be used to resolve disputes between the shipper and
            the carrier, as it is legally recognized as evidence. In contrast, the freight bill is typically not
            used for dispute resolution but is essential for financial tracking and management.
          </p>
        </div>
      </div>
    </section>
  );
};

export default SectionDifferences;